
	export interface I2DValueProvider<T> {
		getX(seriesItem: T): number;
		getY(seriesItem: T): number;
	}

	export enum SeriesType {
		LINE
	}

	export class SeriesConfiguration {

		public series: Series<any>[] = [];

		public constructor(series: Series<any>[]) {
			this.series = series;
		}

	}

	export class Series<T> {

		public name: string;
		public color: string;
		public type: SeriesType;
		public values: Array<T> = [];
		public valueProvider: I2DValueProvider<T>;

		public constructor(valueProvider: I2DValueProvider<T>, name?: string, color?:string) {
			this.valueProvider = valueProvider;
			this.name = name;
			this.color = color;
		}
	}

	export class TimeSeries extends Series<[number, number]> {

		 public constructor(name?: string, color?: string){
			 super({
				 getX(item: [number, number]){ return (item)? item[0]: undefined; },
				 getY(item: [number, number]){ return (item)? item[1]: undefined; }
			 }, name, color);
		 }

	}
